import { Select } from "antd";
import { statesList } from "../../constant";

const SelectTag = ({ value, onChange, showSearch = true }) => {
  return (
    <>
      <Select
        value={value}
        onChange={onChange}
        style={{
          width: "100%",
          height: "47.6px",
        }}
        options={statesList.map((state) => ({ label: state, value: state }))}
        className="select-class"
        placeholder="Select State"
        showSearch={showSearch}
        filterOption={(input, option) => {
          return option?.label?.toString().toLowerCase().includes(input.toLowerCase());
        }}
      />
    </>
  );
};

export default SelectTag;
